import Rails from 'rails-ujs';
import flag from 'country-code-emoji';
import 'jquery-html5storage';

function OnLoad () {
  var self = this;

  this.init = function () {
    Rails.start();
    self.addListeners();
    self.checkAcceptCookies();
    self.setSession();
    // $('.autopop').popover({ html: true, container: 'body', animation: true });
    $('.js-commify').each(function () { self.commify($(this)); });
    $('.video_click').on('click', self.ytClick);
    $('[data-country-code]').each((_idx, el) => $(el).text(flag($(el).attr('data-country-code'))));
    window.dispatchEvent(new Event('after-pageload'));
  };

  this.acceptCookies = function () {
    $('.cookiepolicy').removeClass('show-cookie-policy');
    $.cookie('bml_cookie_accept', 'true', { expires: 365, path: '/' });
  };

  this.addListeners = function () {
    $('.js-accept-cookies').on('click', self.acceptCookies);
    $(document).on('keyup change', '.js-commify', function () { self.commify($(this)); });
    $('.flash-close').on('click', function () { $('.flash-wrapper').slideUp(Bonkers.animationTime); });
    $('form.forms, .forms form').on('submit', self.formSubmit);
    $('select[data-auto-submit]').on('change', function () { $(this).parents('form').submit(); });
    $('input[type="radio"][data-auto-submit]').on('change', function () { $(this).parents('form').submit(); });
    $('[data-invalid-option-value]').on('change', self.checkInvalidOption);
  };

  this.checkAcceptCookies = function () {
    if ($.cookie('bml_cookie_accept') === undefined) {
      $('.cookiepolicy').addClass('show-cookie-policy');
    }
  };

  this.checkInvalidOption = function (e) {
    var el = e.target;
    if (el.value === el.dataset.invalidOptionValue) {
      el.setCustomValidity(el.dataset.invalidOptionMessage);
      el.setAttribute('required', true);
    } else {
      el.setCustomValidity('');
      el.removeAttribute('required');
    }
    el.reportValidity();
  };

  this.commify = function ($el) {
    let opts = { currency: 'EUR' };
    var val = parseInt($el.val().replace(/[^.0-9]/g, ''));
    if (isNaN(val)) {
      val = null;
    };
    $el.val((val || val === 0) ? Intl.NumberFormat('en-IE', opts).format(val) : null);
  };

  this.formSubmit = function (e) {
    var $button = $(e.target).find('button[type="submit"]');
    $button.attr('disabled', true);
    if ($button.length === 0) {
      return true;
    }
    $button.one(Bonkers.transitionEvents, function () {
      $button.off(Bonkers.transitionEvents);
      $button.removeClass('pending').text('').one(Bonkers.transitionEvents, function () {
        return true;
      }).addClass('active');
    }).addClass('pending');
  };

  this.setSession = function () {
    $('meta[property="session"]').each(function (_idx, el) {
      var $el = $(el);
      $.sessionStorage.setItem($el.attr('data-key'), $el.attr('content'));
    });
  };

  this.ytClick = function () {
    var $el = $(this);
    $el.off('click');
    var $frame = $el.siblings('.video_container').find('.ytframe');
    $frame.attr('src', $frame.data('url'));
    setTimeout(function () { $el.remove(); }, 300);
  };
};

$(function () {
  var onload = new OnLoad();
  onload.init();
});

document.addEventListener('DOMContentLoaded', function () {
  var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));

  if ('IntersectionObserver' in window) {
    let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove('lazy');
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {

  }
});
